import type { SectionId } from '../../shared/types';

/**
 * Derives details about the active list item from a list key.
 * Handles both single mode keys (type:id:position) and multi mode keys (sectionId:type:id:position).
 *
 * @param activeItem - The list key string to parse, or null
 * @returns An object containing details about the active list item, including sectionId if present
 */
export function getActiveListItemDetails(activeItem: string | null) {
  if (!activeItem) {
    return {
      isItemSelected: false,
      itemType: undefined,
      itemId: undefined,
      itemPosition: undefined,
      sectionId: undefined,
    } as const;
  }

  const parts = activeItem.split(':');

  // Multi mode: sectionId:type:id:position
  if (parts.length === 4) {
    const [sectionId, itemType, itemId, itemPos] = parts;
    const position = parseInt(itemPos, 10);
    return {
      isItemSelected: true,
      itemId,
      itemPosition: position || 1,
      itemType,
      sectionId: sectionId as SectionId,
    } as const;
  }

  // Single mode: type:id:position
  const [itemType, itemId, itemPos] = parts;
  const position = parseInt(itemPos, 10);
  return {
    isItemSelected: true,
    itemId,
    itemPosition: position || 1,
    itemType,
    sectionId: undefined,
  } as const;
}
